export const SORT_TYPES = {
  text: { asc: 'A → Z', desc: 'Z → A' },
  date: { asc: 'Earliest → Latest', desc: 'Latest → Earliest' },
  number: { asc: '1 → 9', desc: '9 → 1' },
  currency: { asc: 'Lowest → Highest', desc: 'Highest → Lowest' },
};

export const OFFERS_COLUMNS = [
  { id: 'event_name', label: 'Event', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'artist_name', label: 'Artist', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'dollar_amount', label: 'Amount', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'state', label: 'Status', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'act_type', label: 'Type', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'created_at', label: 'Created Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'owner_name', label: 'Created By', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'buyer_name', label: 'Buyer', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'start_date', label: 'Event Date', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'date' },
  { id: 'has_event', label: 'Event Status', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'has_holds', label: 'Holds', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'genres', label: 'Genre', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'expires_at', label: 'Expires', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'date' },
];

export const getDefaultVisibleColumns = () =>
  OFFERS_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  OFFERS_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
